import { apiClient } from "./apiclient";

// CREATE Work Nature
export const createWorkNature = (data, token) =>
  apiClient.post("/work-Natures", data, {
    headers: { Authorization: `Bearer ${token}` },
  });

// GET All Work Natures
export const getAllWorkNatures = (token) =>
  apiClient.get("/work-Natures", {
    headers: { Authorization: `Bearer ${token}` },
  });

// UPDATE Work Nature
export const updateWorkNature = (id, data, token) =>
  apiClient.put(`/work-Natures/${id}`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
  
// DELETE Work Nature
export const deleteWorkNature = (id, token) =>
  apiClient.delete(`/work-Natures/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
